import { toastr } from 'react-redux-toastr';
import * as Service from '../../server/RestClients';

export const GET_PREDICTION_LOADING = 'GET_PREDICTION_LOADING';
export const GET_PREDICTIONS_SUCCESS = 'GET_PREDICTIONS_SUCCESS';
export const GET_PREDICTION_SUCCESS = 'GET_PREDICTION_SUCCESS';
export const GET_PREDICTION_FAILURE = 'GET_PREDICTION_FAILURE';
export const GET_PREDICTIONS_FAILURE = 'GET_PREDICTIONS_FAILURE';
export const CLEAR_PREDICTIONS_LIST = 'CLEAR_PREDICTIONS_LIST;';

export const makePrediction = (config, i, _options) => async (dispatch) => {
  dispatch({
    type: GET_PREDICTION_LOADING,
  });
  try {
    const prediction = await Service.makePrediction(config, _options);
    dispatch({
      type: GET_PREDICTION_SUCCESS,
      payload: {
        prediction,
        i,
      },
    });
  } catch (e) {
    dispatch({
      type: GET_PREDICTION_FAILURE,
      payload: e,
    });
    toastr.error(
      'Failed to make prediction',
      'Please check your connection config'
    );
  }
};

// eslint-disable-next-line consistent-return
export const makePredictions = (_options, flags) => async (dispatch) => {
  dispatch({
    type: GET_PREDICTION_LOADING,
  });
  try {
    const predictions = await Service.makePredictions(_options, flags);
    dispatch({
      type: GET_PREDICTIONS_SUCCESS,
      payload: predictions,
    });
  } catch (e) {
    toastr.error(
      'Failed to make predictions',
      'Please check your connection config'
    );
    dispatch({
      type: GET_PREDICTIONS_FAILURE,
      payload: e,
    });
  }
};

export const clearPredictionsList = (i) => async (dispatch) => {
  dispatch({
    type: CLEAR_PREDICTIONS_LIST,
    payload: {
      i,
    },
  });
};
